import { render, staticRenderFns } from "./ObjectCardComments.vue?vue&type=template&id=e1b094b6&scoped=true&"
import script from "./ObjectCardComments.vue?vue&type=script&lang=js&"
export * from "./ObjectCardComments.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardComments.vue?vue&type=style&index=0&id=e1b094b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b094b6",
  null
  
)

export default component.exports